import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./city-card-buttons.module.scss";
import { useNavigate } from "react-router-dom";
import CardButton from "./card-button/card-button";
import { useAppSelector } from "../../../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../../../hooks/useAppDispatch";
import { MapSection } from "../../../../../services/reducers/map";
import { extentEstateEn } from "../../../../../services/actions/map";

interface Props {
  plotsAvailable: number;
  spacesForRentAvailable: number;
  investmentOpportunities: number;
  estateEn: number;
  estateName: string;
}

export default function CityCardButtons({
  plotsAvailable,
  spacesForRentAvailable,
  investmentOpportunities,
  estateEn,
  estateName,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { mapComponentReady } = useAppSelector((state) => state.map);

  function onOpenSearch(filter: string) {
    const params = new URLSearchParams();
    params.append("city", String(estateEn));
    params.append("res", "true");

    if (estateName && estateEn && mapComponentReady === MapSection.search) {
      dispatch(extentEstateEn({ estateEn, highlightFeature: false }));
    }

    navigate(`/search/${filter}?${params.toString()}`);
  }

  return (
    <div className={styles.cityCardButtons}>
      {plotsAvailable && (
        <CardButton
          count={plotsAvailable}
          onClick={() => onOpenSearch("plt")}
          buttonName={t("city-card.plotsAvailable")}
        />
      )}
      {spacesForRentAvailable && (
        <CardButton
          count={spacesForRentAvailable}
          onClick={() => onOpenSearch("spc")}
          buttonName={t("city-card.spacesForRent")}
        />
      )}
      {investmentOpportunities && (
        <CardButton
          count={investmentOpportunities}
          className={styles.investmentOpportunities}
          onClick={() => onOpenSearch("invop")}
          buttonName={t("city-card.investmentOpportunities")}
        />
      )}
    </div>
  );
}
